module.exports = __webpack_public_path__ + "img/2.405a69cc.png";